export enum DemandTab {
    VESSELS = 'vessels',
    BUNKER_PLAN = 'bunkerPlan',
}
